/**
 * @generated SignedSource<<991decc088e5e95c5fcc0f2dc3bb434a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmployeeScheduleShiftsEmployee_employee$data = {
  readonly id: string;
  readonly shifts: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleShiftBar">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleShiftsEmployeeNamePanel_employee">;
  readonly " $fragmentType": "EmployeeScheduleShiftsEmployee_employee";
};
export type EmployeeScheduleShiftsEmployee_employee$key = {
  readonly " $data"?: EmployeeScheduleShiftsEmployee_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleShiftsEmployee_employee">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmployeeScheduleShiftsEmployee_employee",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EmployeeScheduleShiftsEmployeeNamePanel_employee"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeShift",
      "kind": "LinkedField",
      "name": "shifts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployeeScheduleShiftBar"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};
})();

(node as any).hash = "cbfe7ea1c7777a4ea31de9e7cad3029b";

export default node;
